import { Dealer } from './Dealer.model';
import { Integrator } from './integrator';
import { License } from './license.model';
import { OOCanvas } from './oo-canvas';
import { OOLink } from './oo-link';
import { OOMenuItem } from './oo-menu-item';
import { OOMenuStatus } from './oo-menu-status';
import { OOPriceLevel } from './oo-price-level';
import { OOStyles } from './oo-styles';
import { OOVenue } from './oo-venue';
import { PrintOrder } from './PrintOrder';
import { VenueCreditStatus } from './VenueCreditStatus';
import { VenueKitchenDevicePreferences } from './VenueKitchenDevicePreferences.entity';
import { VenuePayDevicePreference } from './VenuePayDevicePreferences.entity';
import { VenuePos } from './VenuePos.entity';
import { VenueStatus } from './VenueStatus.model';

export class Store {
	key: number;
	name: string;
	mode: string;
	workingDirectory: string;
	dealerKey: string;
	demo: boolean;
	legacy: boolean;
	integrations: string[];
	dealer: Dealer;

	connectorLicense: boolean;
	connectorStatus: string;
	connectorClaimed: boolean;
	connectorVersion: string;
	onlineOrder: boolean;
	ooVenue: OOVenue;
	posVersion: string;
	posStatus: number;
	externalIdMenuItemKey: number;
	externalBusinessId: string;
	contractFinanceEnabled: boolean;
	externalDealerAccountingId: string;

	automaticEmployeeMessaging: boolean;

	ccProcessor: number;

	ccProcessorApiKey: string;

	ccProcessorApiSecret: string;

	mcsEnabled: boolean;

	VenueCreditStatus: VenueCreditStatus;
	VenuePos: VenuePos;
	status: VenueStatus;

	active: boolean;

	connectorUptime?: number;

	printOrders: PrintOrder[];

	ooStyles: OOStyles;

	ooMenuStatus: OOMenuStatus;

	ooMenuItems: OOMenuItem[];

	ooCanvases: OOCanvas[];

	ooPriceLevels: OOPriceLevel[];

	ooLinks: OOLink[];

	venuePayDevicePreferences: VenuePayDevicePreference;

	venueKitchenDevicePreferences: VenueKitchenDevicePreferences;

	posCloseDayTime: string;

	laborCutoffTime: string;

	ooMenuResync: boolean;

	timezone: string;

	twilioSid: string;

	twilioAccountToken: string;

	categories: string[];

	datafeedPollingEnabled: boolean;

	debug: boolean;

	integrators: string[];
	venueIntegrators: Integrator[] = [];
	licenses: License[];
	financial?: {
		billing: {
			onPay: number;
			onOrder: number;
			kitchen: number;
		};
		counts: {
			active: number;
			inactive: number;
			demo: number;
			connector: number;
			onPayLicenses: number;
			onOrderLicenses: number;
			onOrderPacks: number;
			onPayPacks: number;
			kitchen: number;
		};
	};

	displayName?: string;

	public constructor(init?: Partial<Store>) {
		Object.assign(this, init);
	}
}
